import { Component, OnInit, ViewChild, ElementRef, OnDestroy, AfterViewInit, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core';
import { Router, NavigationEnd, RoutesRecognized, ActivatedRoute, Event } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormGroupDirective, AbstractControl, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { emailValidator, EmailMatchValidation } from 'src/app/theme/utils/app-validators';
import { ApiService } from 'src/app/shared/services/api.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { displayErrorMessage } from 'src/app/theme/utils/util-functions';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { filter, pairwise, map, startWith } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
declare var grecaptcha: any;
import { environment } from 'src/environments/environment';
import { NgZone } from '@angular/core';
import { storeLinksType } from 'src/app/types/sign-in'
import { FeatureTagObject } from 'src/app/types/feature-tags';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import { isPlatformBrowser } from '@angular/common';
import { isTokenExpiryEnabled } from 'src/app/theme/utils/feature-tag';
import { HttpErrorResponse } from '@angular/common/http';
import { TrackingService } from 'src/app/shared/services/tracking.service';
// declare var CryptoJS
@Component({
    selector: "app-sign-in",
    templateUrl: "./sign-in.component.html",
    styleUrls: ["./sign-in.component.scss"],
})
export class SignInComponent implements OnInit, OnDestroy {
    loginForm: FormGroup;
    registerForm: FormGroup;
    otpForm: FormGroup;
    redirectURL: any;
    known_by = [
        "Word of Mouth",
        "Google",
        "Mail (Postcard)",
        "News",
        "Flyer",
        "TV Commercial",
        "Facebook",
        "Seen Milk Truck",
        "Ad Sign",
    ];
    filteredKnownBy: Observable<string[]>;
    userDetails = null;
    previousUrl: string;
    params: any;
    isLoadingSignInBtn: boolean = false;
    isLoadingSignUpBtn: boolean = false;
    sendOtpBtn: boolean = false;
    verifyOtpBtn: boolean = false;
    showVerifyOtp: boolean = false;
    subscripeNavigation: Subscription;
    sub;
    timeLeft: number = 90;
    interval;
    confirmationResult;
    resendAttempt = 1;
    appVerifierDupe;
    storeLinksJson: storeLinksType[] = [];
    termsOfUse: string;
    privacyPolicy: string;
    featureTags: FeatureTagObject = <FeatureTagObject>{};
    returnUrl: string;
    enableCartWithoutRegistration: boolean = null;


    constructor(
        public formBuilder: FormBuilder,
        public router: Router,
        public snackBar: MatSnackBar,
        private notification: NotificationService,
        private apiService: ApiService,
        private subscription: SubscriptionService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute,
        private cookieService: CookieService,
        public ngZone: NgZone,
        private changeDetectRef: ChangeDetectorRef,
        public sharedDataservice: SharedDataService,  
        @Inject(PLATFORM_ID) private platformId: Object,
        public sharedDataService: SharedDataService,
        public trackingService: TrackingService,
    ) {
        this.router.events
            .pipe(
                filter((evt: any) => evt instanceof RoutesRecognized),
                pairwise()
            )
            .subscribe((events: RoutesRecognized[]) => {
                this.redirectURL = events[0].urlAfterRedirects;
            });
    }

    @ViewChild("loginEmailId", { read: ElementRef, static: true })
    loginEmailId: ElementRef;

    ngOnInit() {
        this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));
        this.getStoreDetails();
        this.enableCartWithoutRegistration = this.subscription.getCartWithoutRegistrationStatus()
        // if (!!this.featureTags?.["enable_disable_cart_without_registration"]) {
        this.checkAndSetReturnUrl();
        // }

        this.loginForm = this.formBuilder.group({
            email_id: [
                "",
                Validators.compose([Validators.required, emailValidator]),
            ],
            password: [
                "",
                Validators.compose([
                    Validators.required,
                    Validators.minLength(6),
                ]),
            ],
            rememberMe: [false],
        });
        this.otpForm = this.formBuilder.group({
            phone: [undefined, [Validators.required]],
            verifyOtp: ["", Validators.pattern(/^[0-9]\d*$/)],
        });
        this.registerForm = this.formBuilder.group(
            {
                first_name: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(35),
                    ]),
                ],
                last_name: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.maxLength(35),
                    ]),
                ],
                email_id: [
                    "",
                    Validators.compose([Validators.required, emailValidator]),
                ],
                verify_email_id: [
                    "",
                    Validators.compose([Validators.required, emailValidator]),
                ],
                password: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.minLength(6),
                    ]),
                ],
                phone_number: [
                    "",
                    Validators.compose([
                        Validators.required,
                        Validators.minLength(10),
                    ]),
                ],
                known_by: ["", Validators.compose([Validators.required])],
                newsletter_subscription: ["true"],
            },
            {
                validator: EmailMatchValidation.MatchPassword,
            }
        );
        this.activatedRoute.queryParams.subscribe(params => {
            let signInId = params['id']; //
            if (!!params['id']) {
                this.autoLogin(signInId);
            }
        });
        this.params = this.activatedRoute.snapshot.queryParams;
        if (this.params["redirectURL"]) {
            this.redirectURL = this.params["redirectURL"];
        }

        this.filteredKnownBy = this.registerForm
            .get("known_by")
            .valueChanges.pipe(
                startWith(""),
                map((val) => this.filterForKnownBy(val))
            );
        this.rememberMe("normal");
        this.sub = this.subscription.getSubject().subscribe((value) => {
            if (!!value && value["loginwithRememberMe"]) {
                this.rememberMe("automatic");
            }
        });

        // if (!!this.featureTags?.["add_href_for_termsOfUse_and_privacyPolicy"]) {
        this.getLinks();
        // }

        if (isTokenExpiryEnabled(this.featureTags)) {
            if (!this.apiService.loggedIn() && isPlatformBrowser(this.platformId)) {
              // console.warn("====> Clearing local items due to logout from another tab.")
              this.sharedDataService.cartDataSource.next(false);
            }
        }
    }

    autoLogin(token: string) {
        this.notification.showSpinner();
        this.apiService.customerLoginApiV2({ customer_token: token, impersonate: "impersonate" }).subscribe(
            (res) => {
                if (res["response"].status === 5) {
                    this.notification.warning(
                        res["response"].message,
                        5000
                    );
                    this.isLoadingSignInBtn = false;
                    this.notification.hideSpinner();

                } else if (res["response"].status === 7) {
                    this.notification.error(res["response"].message, 5000);
                    this.isLoadingSignInBtn = false;
                    this.notification.hideSpinner();

                } else if (
                    res["response"].status === 2 ||
                    res["response"].status === 3
                ) {
                    displayErrorMessage({
                        notification: this.notification,
                        response: res["response"],
                        formControl: this.loginForm.controls,
                    });
                    this.isLoadingSignInBtn = false;
                    this.notification.hideSpinner();

                } else if (res["response"].status === 1) {
                    if (this.loginForm.value.rememberMe) {
                        var password = CryptoJS.AES.encrypt(
                            this.loginForm.value.password.trim(),
                            "hjgefbugigc47567869vbl489235785678yn64"
                        ).toString();
                        this.cookieService.set(
                            "rememberMe",
                            JSON.stringify({
                                rememberMe: true,
                                email_id: this.loginForm.value["email_id"],
                                password: password,
                            }),
                            null,
                            null,
                            null,
                            null,
                            null
                        );
                    } else if (this.loginForm.value.rememberMe === false) {
                        this.cookieService.delete("rememberMe", "/");
                        this.cookieService.deleteAll();
                    }
                    this.setLoginDetails(res["response"]["data"]);
                    this.notification.hideSpinner();

                }
            },
            (error: HttpErrorResponse) => {
                this.trackingService.track(error)
                this.isLoadingSignInBtn = false;
                if (error.status === 0) {
                    const message = `Unable to connect to the server. Please check your internet connection status and try again, or contact the support team.`;
                    this.notification.error(message, 5000);
                } else {
                    this.notification.error(error.message, 5000);
                }
            }
        );
    }
    checkAndSetReturnUrl() {
        try {
            const browserUrlTree = this.router.parseUrl(this.router.url);
            const browserQueryParams = browserUrlTree.queryParams;
            this.returnUrl = browserQueryParams.returnUrl;
        } catch (error) {
            console.log(error.message);
        }
    }
    getLinks() {
        try {
            let storeLinks: storeLinksType[] = JSON.parse(
                sessionStorage.getItem("storeLinks")
            );
            storeLinks.filter((link) => {
                if (link.label === "terms_of_use") {
                    this.termsOfUse = link?.href;
                }

                if (link.label === "privacy_policy") {
                    this.privacyPolicy = link?.href;
                }
            });
        } catch (error) {
            console.log(error.message);
        }
    }
    rememberMe(value) {
        if (!!this.cookieService.get("rememberMe")) {
            const rememberMe = JSON.parse(this.cookieService.get("rememberMe"));
            if (!!rememberMe) {
                this.loginForm.patchValue({
                    email_id: rememberMe["email_id"],
                    password: CryptoJS.AES.decrypt(
                        rememberMe["password"],
                        "hjgefbugigc47567869vbl489235785678yn64"
                    ).toString(CryptoJS.enc.Utf8),
                    rememberMe: rememberMe["rememberMe"],
                });
            }
            if (value === "automatic") {
                this.onLoginFormSubmit(this.loginForm.value);
            }
        }
    }
    recaptchaVerifierInitiate() { }
    ngAfterViewInit() { }
    asyncValidatePhone(control: AbstractControl) {
        return this.apiService
            .checkCustomerIsAlreadyExist({
                website_check: "global",
                phone_number: parseInt(
                    control.parent.controls["phone"].value.slice(-10)
                ),
            })
            .pipe(
                map((response) => {
                    if (
                        !response["response"]["status"] ||
                        response["response"]["status"] !== 4
                    ) {
                        return {
                            phoneTaken: true,
                            dupEmailError: "Phone Number does not exists!",
                        };
                    }
                })
            );
    }
    emailMatchValidator(control: FormControl): { [s: string]: boolean } {
        if (
            this.registerForm &&
            control.value.toLowerCase() !==
            this.registerForm["controls"]["email_id"].value.toLowerCase()
        ) {
            return { emailMismatch: true };
        }
        return null;
    }
    getPhoneNumberFromUserInput(event) { }
    ngOnDestroy() {
        !!this.sub && this.sub.unsubscribe();
        if (this.interval) {
            clearInterval(this.interval);
        }
        setTimeout(
            () =>
                !!this.subscripeNavigation &&
                this.subscripeNavigation.unsubscribe(),
            4000
        );
    }

    filterForKnownBy(val: string): string[] {
        val = val.toLocaleLowerCase();
        let newOptions = this.known_by.filter((option) =>
            option.toLocaleLowerCase().includes(val)
        );
        return newOptions;
    }

    public onLoginFormSubmit(values: Object): void {
        if (this.loginForm.valid) {
            this.loginForm.value.email_id =
                this.loginForm.value.email_id.toLowerCase();
            this.isLoadingSignInBtn = true;
            this.apiService.customerLoginApiV2(this.loginForm.value).subscribe(
                (res) => {
                    if (res["response"].status === 5) {
                        this.notification.warning(
                            res["response"].message,
                            5000
                        );
                        this.isLoadingSignInBtn = false;
                    } else if (res["response"].status === 7) {
                        this.notification.error(res["response"].message, 5000);
                        this.isLoadingSignInBtn = false;
                    } else if (
                        res["response"].status === 2 ||
                        res["response"].status === 3
                    ) {
                        displayErrorMessage({
                            notification: this.notification,
                            response: res["response"],
                            formControl: this.loginForm.controls,
                        });
                        this.isLoadingSignInBtn = false;
                    } else if (res["response"].status === 1) {
                        if (this.loginForm.value.rememberMe) {
                            var password = CryptoJS.AES.encrypt(
                                this.loginForm.value.password.trim(),
                                "hjgefbugigc47567869vbl489235785678yn64"
                            ).toString();
                            this.cookieService.set(
                                "rememberMe",
                                JSON.stringify({
                                    rememberMe: true,
                                    email_id: this.loginForm.value["email_id"],
                                    password: password,
                                }),
                                null,
                                null,
                                null,
                                null,
                                null
                            );
                        } else if (this.loginForm.value.rememberMe === false) {
                            this.cookieService.delete("rememberMe", "/");
                            this.cookieService.deleteAll();
                        }
                        this.setLoginDetails(res["response"]["data"]);
                    }
                },
                (error: HttpErrorResponse) => {
                    this.trackingService.track(error)
                    this.isLoadingSignInBtn = false;
                    if (error.status === 0) {
                        const message = `Unable to connect to the server. Please check your internet connection status and try again, or contact the support team.`;
                        this.notification.error(message, 5000);
                    } else {
                        this.notification.error(error.message, 5000);
                    }
                }
            );
        }
    }

    public onRegisterFormSubmit(
        values: Object,
        resetRegisterForm: FormGroupDirective
    ): void {
        if (
            this.registerForm["controls"][
                "verify_email_id"
            ].value.toLowerCase() !==
            this.registerForm["controls"]["email_id"].value.toLowerCase()
        ) {
            this.notification.warning("Email and Verify email Mismatch!", 5000);
            return;
        }
        if (this.registerForm.valid) {
            let newsletter_subscription = this.registerForm.value
                .newsletter_subscription
                ? "true"
                : "false";
            this.registerForm.value.newsletter_subscription =
                newsletter_subscription;
            this.registerForm.value.email_id =
                this.registerForm.value.email_id.toLowerCase();
            this.isLoadingSignUpBtn = true;
            this.apiService.customerRegister(this.registerForm.value).subscribe(
                (res) => {
                    if (res["response"].status === 5) {
                        this.notification.warning(
                            res["response"].message,
                            5000
                        );
                        this.isLoadingSignUpBtn = false;
                    } else if (res["response"].status === 7) {
                        this.notification.error(res["response"].message), 5000;
                        this.isLoadingSignUpBtn = false;
                    } else if (res["response"].status === 1) {
                        let resData = res["response"]["data"];
                        if (!!resData) {
                            this.notification.success(
                                res["response"].message,
                                5000
                            );
                            this.setLoginDetails(res["response"]["data"]);
                        } else {
                            resetRegisterForm.resetForm();
                            this.registerForm.reset();
                            this.loginEmailId.nativeElement.focus();
                            this.notification.success(
                                res["response"].message,
                                5000
                            );
                            this.isLoadingSignUpBtn = false;
                        }
                    } else if (res["response"].status === 0) {
                        this.notification.error(res["response"].message, 5000);
                        this.isLoadingSignUpBtn = false;
                    } else if (
                        res["response"].status === 2 ||
                        res["response"].status === 3
                    ) {
                        displayErrorMessage({
                            notification: this.notification,
                            response: res["response"],
                            formControl: this.registerForm.controls,
                        });
                        this.isLoadingSignUpBtn = false;
                    }
                },
                (err) => {
                    this.isLoadingSignUpBtn = false;
                    console.log(err);
                }
            );
        }
    }

    setLoginDetails(response: any) {
        this.notification.showSpinner();
        this.subscripeNavigation = this.router.events.subscribe(
            (event: Event) => {
                if (event instanceof NavigationEnd) {
                    this.isLoadingSignInBtn = false;
                    this.isLoadingSignUpBtn = false;
                }
            }
        );
        localStorage.setItem("token", response.token);
        this.apiService.setLogin({
            loggedIn: true,
            userDetails: response.user_details,
        });
        if (response["cut_off_details"]["delivery_date"] !== null) {
            var cutOffTime = [
                {
                    storeCutOffTime:
                        response["cut_off_details"]["store_date_time"]["date"],
                    currentDateAndtime:
                        response["cut_off_details"]["current_date_time"][
                        "date"
                        ],
                    orderDeliveryDate:
                        response["cut_off_details"]["delivery_date"],
                    storeDeliveryDate:
                        response["cut_off_details"]["store_delivery_date"],
                    deliveryDay: response.user_details["delivery_day"],
                    orderStatus: response["cut_off_details"]["order_status"],
                    orderPresent: response["cut_off_details"]["order"],
                },
            ];
            sessionStorage.setItem("cutoff", JSON.stringify(cutOffTime));
            sessionStorage.setItem(
                "selected_delivery_date",
                response["cut_off_details"]["delivery_date"]
            );
        }
        if (!!this.featureTags && this.featureTags['ftag_allow_product_to_customer_based_events']) {
            if(response.user_details.user_event_ids){
                sessionStorage.setItem('user_event_ids', JSON.stringify(response.user_details.user_event_ids));
            }
        }
        let cartData = JSON.parse(sessionStorage.getItem("cart"));
        // if (!!this.featureTags['seasonal_products']) {
        if (this.redirectURL && this.redirectURL.includes("pre-cart")) {
            var pre_order_item = localStorage.getItem('pre_order_item');
            sessionStorage.setItem('pre_order_item', pre_order_item);
            localStorage.removeItem('pre_order_item');
            this.router.navigate(["pre-cart"]);
            return;
        }
        // }
        if (!!this.featureTags && this.featureTags['ftags_membership']) {
            if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                if (this.sharedDataservice.redirectToMembership) {
                    this.sharedDataservice.setRedirectToMembership(false); 
                    this.router.navigate(['/membership-purchase']);
                }else if(this.storeDetails['enable_bulletin_board'] == true){
                    if(this.storeDetails['bulletin_board_as_landing'] == true){
                        this.router.navigate(["/account/bulletinboard"]) 
                    }else{
                        this.router.navigate(["/account/orders"]) 
                    }
                }else if(this.storeDetails['enable_bulletin_board'] == false){
                    this.router.navigate(["/account/orders"]) 
                }
                 else {
                    this.router.navigate(["/" +this.checkRedirectionPage("Page")])
                }
            }else{
                if (this.sharedDataservice.redirectToMembership) {
                    this.sharedDataservice.setRedirectToMembership(false); 
                    this.router.navigate(['/membership-purchase']);
                } else {
                    this.router.navigate(["/" +this.checkRedirectionPage("Page")])
                }
            }   
        }else{
            if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) { 
                if(this.storeDetails['enable_bulletin_board'] == true){
                    if(this.storeDetails['bulletin_board_as_landing'] == true){
                        this.router.navigate(["/account/bulletinboard"]) 
                    
                    }else{
                        this.router.navigate(["/account/orders"]) 
                    
                    }
                }else if(this.storeDetails['enable_bulletin_board'] == false){
                    this.router.navigate(["/account/orders"])  
                }else {
                    this.router.navigate(["/" +this.checkRedirectionPage("Page")])
                }
            }
             else {
                this.router.navigate(["/" +this.checkRedirectionPage("Page")])
            }
            
        }     
        this.notification.hideSpinner();
        sessionStorage.setItem("order_exist", response["order_exist"]);

        this.notification.success("You logged in successfully!", 5000);
    }
    calculateCartData(data: Array<Object>) {
        let totalItems = !!data ? data.length : 0;
    }
    checkRedirectionPage(route) {
        if (route == "RouteName") {
            return "All Categories";
        } else if (route == "Page") {
            return "account";
        } else {
            return "Bulletin Board";
        }
    }

    storeCartProduct(cartData: any, sendSubject: boolean = false) {
        if (!!cartData) {
            cartData = cartData.map((val) => {
                return {
                    id: val["product"]["id"],
                    quantity: val["quantity"],
                    frequency: val["frequency"],
                };
            });
            var data = {
                values: cartData,
            };
            let specialInstruction = localStorage.getItem("specialInstruction");
            let deliveryInstruction = localStorage.getItem(
                "deliveryInstruction"
            );
            let count = localStorage.getItem("pageCount");
            this.apiService.addCart(data).subscribe(
                (result) => {
                    // localStorage.clear();
                    // if(!!specialInstruction) {
                    //   localStorage.setItem('specialInstruction', specialInstruction);
                    // }
                    if (!!deliveryInstruction) {
                        localStorage.setItem(
                            "deliveryInstruction",
                            deliveryInstruction
                        );
                    }
                    !!count && localStorage.setItem("pageCount", count);
                    sendSubject;
                    // && this.subscription.subjectNext({value: 'Get cart'});
                    if (result["response"]["status"] === 1) {
                    } else {
                    }
                },
                (error) => {
                    if (error) {
                        console.log(error);
                    }
                }
            );
            if (!!specialInstruction) {
                var orderComments = {
                    order_comment: specialInstruction,
                };
                this.apiService
                    .saveOrderComments(orderComments)
                    .subscribe((result) => { });
            }
        }
    }
    redirectTo() {

        // if (!!this.featureTags?.["enable_disable_cart_without_registration"]) {
        if (!this.enableCartWithoutRegistration) {
            if (this.redirectIfReturnUrlExist() === false) {
                return
            }
        }
        // }


        if (this.redirectURL && this.redirectURL.includes("cart")) {
            this.router
                .navigate(["/edit-order"])
                .catch(() => this.router.navigate(["/account/orders"]));
        } else {
            this.router.navigate(["/edit-order"]);
        }
    }

    redirectIfReturnUrlExist(): boolean {
        try {

            if (!!this.returnUrl && this.returnUrl !== '') {

                this.isLoadingSignInBtn = false;
                this.isLoadingSignUpBtn = false;

                let url_segments = this.returnUrl?.split("/");

                url_segments = url_segments?.filter((segment) => {
                    return segment !== "";
                });
                url_segments[0] = `../${url_segments[0]}`;

                this.router.navigate(url_segments)
                    .catch(() => {
                        this.router.navigate(["/"])
                    })

                this.changeDetectRef.markForCheck();

                return false;
            } else {
                return true
            }
        } catch (error) {
            console.log(error.message);
        }
    }

    countryChangedEvent(event) { }

    /** To store the store details in sessionStorage */
    storeDetails;
    storeDetailsJson;
    getStoreDetails() {
        this.apiService.getStoreDetails().subscribe(result => {
            if (result['response']['status'] === 1) {
                if (!!result['response']['data']['payment_method_details']) {
                    let paymentOption = result['response']['data']['payment_method_details'];                    
                    if(!!this.featureTags && this.featureTags['sf_stripe_payment']){
                        var cardEnable = paymentOption.find(method => method.name === 'authorize_net' ||  method.name === 'stripe') !== undefined;
                    }else{
                        var cardEnable = paymentOption.find(method => method.name === 'authorize_net') !== undefined;
                    }
                }
                sessionStorage.setItem('cardEnable', cardEnable ? "true" : "false");
                if (!!result['response']['data']['store']) {
                    this.storeDetails = result['response']['data']['store'];
                    this.storeDetailsJson = result['response']['data']['store_json'];
                    // save store details in session start
                    this.setStoreValues();
                }
            }
        }, (error) => {
            if (error) {
                console.log(error);
            }
        });
    }

    setStoreValues() {
        sessionStorage.removeItem('storeLinks');
        sessionStorage.removeItem('storeStatus');
        sessionStorage.setItem('store', JSON.stringify({
            id: this.storeDetails['id'],
            name: this.storeDetails['name'],
            logo: this.storeDetails['logo'],
            address: this.storeDetails['address'],
            phone: this.storeDetails['phone'],
            currency: this.storeDetails['currency'],
            site_maintenance: this.storeDetails['site_maintenance'],
            cart_without_registration: this.storeDetails['cart_without_registration'],
            cc_collection_point: this.storeDetails['cc_collection_point'],
            delivery_address_input_preference: this.storeDetails['delivery_address_input_preference'],
            automatic_route_assignment: this.storeDetails['automatic_route_assignment'],
            waitlist_for_non_service_areas: this.storeDetails['waitlist_for_non_service_areas'],
            delivery_fee: this.storeDetails['delivery_fee'],
            fulfillment_options: this.storeDetails['fulfillment_options'],
            delivery_upper_limit: this.storeDetails['delivery_upper_limit'],
            rate_per_bottle: this.storeDetails['rate_per_bottle'],
            date_format: this.storeDetails['date_format'],
            time_zone: this.storeDetails['time_zone'],
            cart: this.storeDetails['cart_without_registration'],
            order_cut_off_day: this.storeDetails['order_cut_off_day'],
            order_cut_off_time: this.storeDetails['order_cut_off_time'],
            siteTitle: this.storeDetailsJson['settings']['siteTitlePrefix'],
            minimum_order_value: this.storeDetails['minimum_order_value']
        }));
        let fullphone = this.storeDetails['phone'];
        var x = fullphone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        fullphone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');

        sessionStorage.setItem('stphone', fullphone);
        sessionStorage.setItem('stemail', this.storeDetails['reply_to_email']);
        sessionStorage.setItem('storeLinks', JSON.stringify(this.storeDetailsJson["links"]));
        sessionStorage.setItem('storeStatus', JSON.stringify(this.storeDetails["mode"]));
        this.subscription.setCartWithoutRegistrationStatus(this.storeDetails['cart_without_registration'])
    }


}